import { render, staticRenderFns } from "./SocialTrafficTable.vue?vue&type=template&id=8be42e5e&scoped=true"
import script from "./SocialTrafficTable.vue?vue&type=script&lang=js"
export * from "./SocialTrafficTable.vue?vue&type=script&lang=js"
import style0 from "./SocialTrafficTable.vue?vue&type=style&index=0&id=8be42e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be42e5e",
  null
  
)

export default component.exports